import { createContext } from 'react';
import type { Skill } from '../../types/skill';

/** 技能页面注入导航能力，详情弹窗不依赖 App 路由或自行操作会话。 */
export const SkillLaunchContext = createContext<{
  /** 当前账号已安装的技能快照；线上技能必须按稳定 ID 匹配，不能仅凭重名。 */
  skills: Skill[];
  /** 仅准备草稿；返回 false 表示技能已失效，详情保持打开。 */
  launch: (skillId: string, question?: string) => boolean;
} | null>(null);
